// extracted by mini-css-extract-plugin
export default {"App":"app_App__m9VsD","main":"app_main__a5nyR","content":"app_content__2B8ui"};